import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React from 'react';
import { withTranslation } from 'react-i18next';
import EditorBuilder from '../../editor/editor-builder';
import OutlineItem from './outline-item';
import '../../assets/css/outline.css';

var OutlineView = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(OutlineView, _React$PureComponent);

  var _super = _createSuper(OutlineView);

  function OutlineView(props) {
    var _this;

    _classCallCheck(this, OutlineView);

    _this = _super.call(this, props);

    _this.scrollToNode = function (node) {
      // wiki module
      if (_this.props.scrollToNode) {
        _this.props.scrollToNode(node);

        return;
      }

      var editorRef = EditorBuilder.getEditorRef();
      editorRef.scrollToNode(node);
    };

    _this.getHeaderList = function (document) {
      var headerList = [];
      document.forEach(function (node, index) {
        if (node.type === 'header_two' || node.type === 'header_three') {
          headerList.push(Object.assign({}, node, {
            path: [index]
          }));
        }
      });

      _this.setState({
        headerList: headerList
      }, function () {
        var updateForNoOutline = _this.props.updateForNoOutline;

        if (headerList.length == 0 && updateForNoOutline) {
          updateForNoOutline();
        }
      });
    };

    _this.state = {
      headerList: null
    };
    return _this;
  }

  _createClass(OutlineView, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.getHeaderList(this.props.document);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.document !== nextProps.document) {
        this.getHeaderList(nextProps.document);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          isViewer = _this$props.isViewer,
          t = _this$props.t;
      var headerList = this.state.headerList;

      if (!headerList || headerList.length === 0) {
        return /*#__PURE__*/React.createElement("div", {
          className: "seafile-editor-outline py-2 pr-4"
        }, isViewer && null, !isViewer && /*#__PURE__*/React.createElement("div", {
          className: "size-panel-no-content"
        }, t('no_out_line')));
      }

      var activeTitleIndex = this.props.activeTitleIndex;
      return /*#__PURE__*/React.createElement("div", {
        className: "seafile-editor-outline py-2 pr-4"
      }, headerList.map(function (node, index) {
        var isActive = index === activeTitleIndex;
        return /*#__PURE__*/React.createElement(OutlineItem, {
          key: index,
          node: node,
          isActive: isActive,
          scrollToNode: _this2.scrollToNode
        });
      }));
    }
  }]);

  return OutlineView;
}(React.PureComponent);

export default withTranslation('seafile-editor')(OutlineView);